var React = require('react');

function IconOther (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinejoin":"round","transform":"translate(48 8)"},[React.createElement("path",{"d":"m112 18.9c0 10.4-8.4 18.9-18.9 18.9-10.4 0-18.9-8.4-18.9-18.9s8.5-18.9 18.9-18.9c10.5 0 18.9 8.4 18.9 18.9z","key":0}),React.createElement("path",{"d":"m112 93.1c0 10.4-8.4 18.9-18.9 18.9-10.4 0-18.9-8.4-18.9-18.9s8.4-18.9 18.9-18.9c10.5.1 18.9 8.5 18.9 18.9z","key":1}),React.createElement("path",{"d":"m37.7 55.4c0 10.4-8.4 18.9-18.9 18.9-10.4 0-18.8-8.5-18.8-18.9s8.4-18.9 18.9-18.9c10.4.1 18.8 8.5 18.8 18.9z","key":2}),React.createElement("path",{"d":"m76.9 28.6-40.4 20.2","key":3}),React.createElement("path",{"d":"m75.3 86.7-41-20.5","key":4})]));
}

IconOther.defaultProps = {"viewBox":"0 0 208 128"};

module.exports = IconOther;

IconOther.default = IconOther;
